var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMembershipCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "membershipCard_svg__svg-safari-fix",
  viewBox: "0 0 16 16",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.687 2.687H3.333c-1.1 0-2 .9-2 2v6.633c0 1.1.9 2 2 2h9.354c1.1 0 2-.9 2-2V4.687c0-1.1-.9-2-2-2M3.333 4.02h9.354c.366 0 .666.3.666.667v.633H2.667v-.633c0-.367.3-.667.666-.667m9.354 7.967H3.333a.67.67 0 0 1-.666-.667V6.653h10.686v4.667c0 .367-.3.666-.666.666",
  clipRule: "evenodd"
})));
export default SvgMembershipCard;